import * as turf from '@turf/turf';
import basin from './basin.json';
import mancat from './mancat.json';
import opcat from './opcat.json';

export const BASIN_OPTIONS = basin;
export const MANAGEMENT_CATCHMENT_OPTIONS: { [key: string]: string[] } = mancat;
export const OPERATIONAL_CATCHMENT_OPTIONS: { [key: string]: string[] } = opcat;

export const getMultiPolygon = (
  catchment: GeoJSON.FeatureCollection
): GeoJSON.Feature<GeoJSON.MultiPolygon> | null => {
  const catchmentFeatures = catchment.features;

  const filteredFeatures = (catchmentFeatures as GeoJSON.Feature[]).filter((feature) =>
    ['Polygon', 'MultiPolygon'].includes(feature.geometry.type)
  );
  const coordinates = filteredFeatures.flatMap((feature) => {
    if (feature.geometry.type === 'Polygon') {
      return [feature.geometry.coordinates];
    } else if (feature.geometry.type === 'MultiPolygon') {
      return feature.geometry.coordinates;
    }
    return null;
  }) as GeoJSON.Position[][][];

  return turf.multiPolygon(coordinates);
};
